module.exports = __webpack_public_path__ + "img/7.552197b4.jpg";